import React from 'react';
import { renderSpacer } from './shared/renderers';

export default function SpacerBlock({ props = {}, theme }) {
  return renderSpacer(props, theme);
}
